module.exports = __webpack_public_path__ + "img/sponsor-4.39f7eb1b.jpg";